<template>
  <div class="cc-root">

    <div class="cc-bg">
      <div class="cc-bg__overlay"></div>
    </div>

    <div class="cc-page">
      <article class="cc-card">

        <div class="cc-card__bar" aria-hidden="true"></div>

        <div class="cc-card__inner">

          <a href="/">
            <img class="cc-logo cc-logo--dark" src="@/assets/CruzControl_Logo_Small_Icon.svg" alt="CruzControl" />
            <img class="cc-logo cc-logo--light" src="@/assets/CruzControl_Logo_Small_Icon_Light.svg" alt="CruzControl" />
          </a>

          <div class="cc-404">
            <p class="cc-404__code">404</p>
            <h1 class="cc-404__title">Page Not Found</h1>
            <p class="cc-404__body">Sorry, we couldn't find the page you're looking for.</p>
            <a href="/" class="cc-submit">
              <span>Go Back Home</span>
              <span class="cc-submit__arrow" aria-hidden="true">→</span>
            </a>
          </div>

        </div>

        <div class="cc-card__foot">
          <a href="#" class="cc-card__support">Contact Support</a>
        </div>

      </article>
    </div>

  </div>
</template>

<script>

export default {
  name: "pageNotFound",
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Big+Shoulders+Display:wght@700;800;900&family=Barlow:wght@300;400;500;600&display=swap');

.cc-root { position: fixed; inset: 0; overflow: hidden; font-family: 'Barlow', sans-serif; }
.cc-bg { position: absolute; inset: 0; z-index: 0; background-color: var(--cc-page); transition: background-color 0.3s; }
.cc-bg__overlay { position: absolute; inset: 0; background: var(--cc-overlay-grad); transition: background 0.3s; }
.cc-page { position: relative; z-index: 10; min-height: 100vh; display: flex; align-items: center; justify-content: center; padding: 1.5rem; }

.cc-card { width: 100%; max-width: 430px; background: var(--cc-card); backdrop-filter: blur(28px) saturate(150%); -webkit-backdrop-filter: blur(28px) saturate(150%); border: 1px solid var(--cc-card-border); border-radius: 4px; overflow: hidden; box-shadow: var(--cc-card-shadow); animation: cardIn 0.65s cubic-bezier(0.16, 1, 0.3, 1) both; transition: background 0.3s, border-color 0.3s, box-shadow 0.3s; }
@keyframes cardIn { from { opacity: 0; transform: translateY(22px) scale(0.97); } to { opacity: 1; transform: translateY(0) scale(1); } }
.cc-card__bar { height: 3px; background: linear-gradient(90deg, #0092bf 0%, #00bcf5 55%, #fcef60 100%); }
.cc-card__inner { padding: 2.25rem 2.5rem 0; }

.cc-logo { height: 42px; width: auto; display: block; margin-bottom: 1.75rem; }
.cc-logo--light { display: none; }
[data-theme="light"] .cc-logo--dark  { display: none; }
[data-theme="light"] .cc-logo--light { display: block; }

.cc-404 { text-align: center; padding: 0.5rem 0 0; }
.cc-404__code { font-family: 'Big Shoulders Display', sans-serif; font-size: 6rem; font-weight: 900; color: #0092bf; line-height: 1; margin: 0; letter-spacing: 0.05em; }
.cc-404__title { font-family: 'Big Shoulders Display', sans-serif; font-size: 1.75rem; font-weight: 700; color: var(--cc-t1); margin: 0.25rem 0 0.75rem; letter-spacing: 0.03em; transition: color 0.3s; }
.cc-404__body { font-size: 0.875rem; color: var(--cc-t3); margin: 0 0 1.5rem; transition: color 0.3s; }

.cc-submit { display: flex; align-items: center; justify-content: center; gap: 0.5rem; width: 100%; background: #0092bf; border: none; border-radius: 3px; padding: 0.875rem 1rem; font-family: 'Barlow', sans-serif; font-size: 0.875rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.10em; color: #ffffff; cursor: pointer; position: relative; overflow: hidden; text-decoration: none; box-sizing: border-box; transition: background 0.2s ease, box-shadow 0.2s ease; }
.cc-submit::after { content: ''; position: absolute; inset: 0; background: linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.10) 50%, transparent 100%); transform: translateX(-100%); transition: transform 0.45s ease; }
.cc-submit:hover::after { transform: translateX(100%); }
.cc-submit:hover { background: #00a8d8; box-shadow: 0 6px 28px rgba(0,146,191,0.42); }
.cc-submit__arrow { font-size: 1rem; display: inline-block; transition: transform 0.2s ease; }
.cc-submit:hover .cc-submit__arrow { transform: translateX(4px); }

.cc-card__foot { margin-top: 2rem; padding: 1rem 2.5rem; border-top: 1px solid var(--cc-card-foot); display: flex; justify-content: center; transition: border-color 0.3s; }
.cc-card__support { font-size: 0.75rem; font-weight: 500; color: var(--cc-t7); text-decoration: none; letter-spacing: 0.02em; transition: color 0.18s; }
.cc-card__support:hover { color: var(--cc-t2); }
</style>